import { ACC_KEY } from '../config'
export const fetchSmbTrackId = async () => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);

  const response = await fetch(
    "https://api.powerlego.com/generate/trackId",
    { method: "POST", headers: myHeaders }
  );
  return response.json();
};

export const fetchSaveSmbStep = async (payload) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);

  try {
    const storedTrackId = sessionStorage.getItem("smbTrackId");
    if (!storedTrackId) {
      throw new Error("TrackId not found");
    }
    const requestData = Object.assign({}, payload, { TrackId: storedTrackId });
    const response = await fetch(
      "https://api.powerlego.com/generate/pageTrack",
      {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(requestData),
      }
    );
    return response.json();
  } catch (error) {
    return error;
  }
};

export const fetchSendSmsCode = async (payload) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);

  try {
    const response = await fetch(
      "https://api.powerlego.com/twoFactor/sendCode",
      {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      }
    );
    return response.json();
  } catch (error) {
    return error;
  }
};

export const fetchVerifySmsCode = async (payload) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);

  try {
    const response = await fetch(
      "https://api.powerlego.com/twoFactor/verifyCode",
      {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      }
    );
    return response.json();
  } catch (error) {
    return error;
  }
};
